// Errors Types
export const HTTP_404_ERROR = 'HTTP_404_ERROR';
export const HTTP_500_ERROR = 'HTTP_500_ERROR';
export const HTTP_OTHER_ERROR = 'HTTP_OTHER_ERROR';

// Errors Modal
export const OPEN_TOAST_ERROR = 'CLOSE_ERROR_MODAL';
export const CLOSE_TOAST_ERROR = 'CLOSE_SUCCESS_MODAL';

// Users Logins Actions
export const OPEN_SESSION = 'OPEN_SESSION';
export const OPEN_FAIL = "LOGIN_FAIL";
export const CLOSE_SESSION = 'CLOSE_SESSION';
export const CREATE_SESSION = 'CREATE_SESSION';

// User Data Actions
export const GET_DATA_SUCCESS = 'GET_DATA_SUCCESS';
export const POST_DATA_SUCCESS = 'POST_DATA_SUCCESS';
export const PUT_DATA_SUCCESS = 'PUT_DATA_SUCCESS';
export const DELETE_DATA_SUCCESS = 'DELETE_DATA_SUCCESS';
export const SAVE_PARTNER_ID = 'SAVE_PARTNER_ID';
export const SAVE_PARTNER = 'SAVE_PARTNER';
export const SAVE_SAVE_ON_ID = 'SAVE_SAVE_ON_ID';

// UI Actions
export const UI_SET_ERROR = 'UI_SET_ERROR';
export const UI_REM_ERROR = 'UI_REM_ERROR';
export const UI_START_LOADING = 'UI_START_LOADING';
export const UI_FINISH_LOADING = 'UI_FINISH_LOADING';
export const UI_SHOW_BOOKING_BAR = 'UI_SHOW_BOOKING_BAR';
export const UI_HIDE_BOOKING_BAR = 'UI_HIDE_BOOKING_BAR';
export const UI_SHOW_NAV_BAR = 'UI_SHOW_NAV_BAR';
export const UI_HIDE_NAV_BAR = 'UI_HIDE_NAV_BAR';
export const UI_SHOW_SAVE_ON_MODAL = 'UI_SHOW_SAVE_ON_MODAL';
export const UI_HIDE_SAVE_ON_MODAL = 'UI_HIDE_SAVE_ON_MODAL';